import React from "react";

import "./App.css";
import "aos/dist/aos.css";

import { Route, Routes } from "react-router-dom";
import { routes } from "./routes";
import Layout from "./components/layout";
import "swiper/css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route element={<Layout />}>
          {routes.map((route) => {
            return (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            );
          })}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
